// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"96":"354265b8e6e2c409","273":"70b749a7dc93c4af","409":"fc9854709f4d71f2","514":"3e2b7a2268bbbdc2","965":"90461f17b51c171b"}[chunkId] + ".js";
};